import EmberRedirect from '~/components/ExternalRedirect/EmberRedirect';
import ExternalRedirect from '~/components/ExternalRedirect/ExternalRedirect';

export { EmberRedirect };
export default ExternalRedirect;
